export const standardColors = ['#ffeb3b', '#52a5ef', '#e84a5f', '#28a745', '#ff9933', '#804180', '#ff3bfb', '#954522'];
